import { useState, useRef } from "react";
import { Card, CardContent, Collapse, IconButton } from '@mui/material'
import Icon from '@mui/material/Icon';

import './summaryCard.scss'

//Preference
import Preferences from 'Core/containers/Preferences';

const SummaryCard = (props) => {
    const { children, onChange, name } = props;
    const [show, setShow] = useState(true);

    const preferencesRef = useRef();

    const changePreferences = (newValues) => {
        const oldPreferences = preferencesRef?.current?.getPreferences("Other", name) || {}
        if (!_.isEqual(newValues, oldPreferences)) {
            const currentPreferences = { ...oldPreferences, accordeon: newValues }
            preferencesRef.current.savePreference("Other", name, currentPreferences)
        }
    }
    
    return (
        <Preferences
            ref={preferencesRef}
            preferencesKey={name}
            onInitialPreferences={(preferences) => {
                if(preferences?.accordeon != undefined && preferences.accordeon != null){
                    let value = preferences?.accordeon
                    setShow(value)
                    onChange && onChange(value)
                }
            }}
        >
            <div className="summary-card">
                <div className="summary-card-btn-wrapper">
                    <div className="summary-card-action-btn">
                        <IconButton
                            className="buttom-collapse"
                            style={{ backgroundColor: 'white' }}
                            onClick={() => {
                                changePreferences(!show)
                                setShow(!show);
                                onChange && onChange(!show)
                            }}
                            size="large">
                            <Icon>
                                {show ? "expand_more" : "expand_less"}
                            </Icon>
                        </IconButton>
                    </div>
                </div>
                <Collapse in={show}>
                    <Card>
                        {
                            show && <CardContent>{children}</CardContent>
                        }
                    </Card>
                </Collapse>
            </div>
        </Preferences>
    );
}

export default SummaryCard;